// disabled scroll on variant change by removing this line from js (line 3397): this.querySelector(`[data-media-id="${event.detail.variant["featured_media"]["id"]}"]`)?.scrollIntoView({ block: "start", behavior: "smooth" });


const assetsLinks = JSON.parse(document.querySelector('#assetsLinks').textContent);

import(assetsLinks.vendorFile)
  .then(module => {
    const { animate } = module;

    document.addEventListener('variant:change', function (event) {

      // disable if quick buy modal is open
      if (document.querySelector("quick-buy-modal[open]")) return;


      let variant = event.detail.variant;
      let previousVariant = event.detail.previousVariant;

      if (variant.option1 !== previousVariant.option1) {
        const variantOptions = variant.options.map(option => option.toLowerCase()) || [];
        const imageWrappers = document.querySelectorAll('.product-gallery__media');
        const regex = /\[(.*?)\]/;

        imageWrappers.forEach(async (imageWrapper, index) => {
          const image = imageWrapper.querySelector('img');
          const optionNames = regex.exec(image.alt) || [];
          const thumbnailWrapper = document.querySelector(`.product-gallery__thumbnail[data-media-id="${imageWrapper.dataset.mediaId}"]`) || null;

          const matching = optionNames && optionNames[1] ? optionNames[1].toLowerCase() : "";

          if (variantOptions.includes(matching)) {
            await animate(imageWrapper, { opacity: 0 }, { duration: 0.2 }).finished
              .then(() => imageWrapper.classList.remove("[.js_&]:tw-hidden"))
              .then(() => thumbnailWrapper.classList.remove("[.js_&]:tw-hidden"))
              .then(() => animate(imageWrapper, { opacity: 1 }, { duration: 0.2 }))
          } else if (image.alt.includes("[") && image.alt.includes("]")) {
            animate(imageWrapper, { opacity: 0 }, { duration: 0.2 }).finished
              .then(() => imageWrapper.classList.add("[.js_&]:tw-hidden"))
              .then(() => thumbnailWrapper.classList.add("[.js_&]:tw-hidden"))
          }
        });
      }
    })

  }).catch(error => {
    console.error('Error importing the module:', error);
  });
